import { Navigate, Outlet } from 'react-router-dom'

const InstanceGuard = ({ isAllowed }: { isAllowed?: boolean }) => {
  return isAllowed ? <Outlet /> : <Navigate to="/" replace />
}

export { InstanceGuard }
